'use es6';

import PortalIdParser from 'PortalIdParser';
import { stringify } from 'hub-http/helpers/params';
import { getReportJson } from './getReportJson';
export const getSandboxLink = () => {
  const portalId = PortalIdParser.get();
  return `/reporting-sandbox/${portalId}/report`;
};
export const getEditLink = report => {
  const queryParams = {
    encoded: getReportJson(report)
  };
  return `${getSandboxLink()}?${stringify(queryParams)}`;
};